// Shared design tokens for consistent UI across the admin panel

export const brand = {
  primary: '#1f5b40',
  primaryLight: '#359163',
  primaryDark: '#133a28',
  accent: '#5ca681',
  surface: '#ffffff',
  canvas: '#f2f6f4',
  canvasAlt: '#e8f0ec',
  border: 'rgba(31, 91, 64, 0.08)',
  borderHover: 'rgba(31, 91, 64, 0.14)',
  borderFocus: 'rgba(31, 91, 64, 0.22)',
  overlay: 'rgba(31, 91, 64, 0.06)',
  overlayHover: 'rgba(31, 91, 64, 0.1)',
  shadowSm: '0 1px 2px rgba(15, 45, 32, 0.04), 0 2px 8px rgba(15, 45, 32, 0.04)',
  shadowMd: '0 4px 12px rgba(15, 45, 32, 0.06), 0 12px 32px rgba(15, 45, 32, 0.06)',
  shadowLg: '0 8px 24px rgba(15, 45, 32, 0.08), 0 24px 48px rgba(15, 45, 32, 0.08)',
  gradient: 'linear-gradient(135deg, #1f5b40 0%, #359163 100%)',
  gradientSoft: 'linear-gradient(135deg, #f8faf9 0%, #eef5f1 50%, #f4f8f6 100%)'
};

export const radius = {
  sm: 8,
  md: 12,
  lg: 16,
  xl: 20
};

/** Destructive actions (delete, remove) — aligned with confirm dialogs */
export const destructive = {
  main: '#b71c1c',
  dark: '#8e0000',
  surface: 'rgba(183, 28, 28, 0.08)',
  surfaceHover: 'rgba(183, 28, 28, 0.14)',
  border: 'rgba(183, 28, 28, 0.22)',
  borderHover: 'rgba(183, 28, 28, 0.38)',
  shadow: '0 2px 8px rgba(183, 28, 28, 0.14)'
};

export default brand;
